export default __webpack_public_path__ + "static/media/side-phone-icon.65bbcae2.svg";